// extracted by mini-css-extract-plugin
export default {"tab":"TabChooseButton_tab__RxRqg","tabActive":"TabChooseButton_tabActive__YSCbn","tabText":"TabChooseButton_tabText__BqkRy"};